import { render, staticRenderFns } from "./checkAuth.vue?vue&type=template&id=56845e70&scoped=true&"
import script from "./checkAuth.vue?vue&type=script&lang=js&"
export * from "./checkAuth.vue?vue&type=script&lang=js&"
import style0 from "./checkAuth.vue?vue&type=style&index=0&id=56845e70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56845e70",
  null
  
)

export default component.exports